<style lang="scss">
  .topHeader {
    margin-bottom: 35px;
    text-align: center;
    h1 {
      margin-top: 0;
      line-height: 30px;
      font-size: 24px;
      font-weight: 800;
      text-transform: uppercase;
    }
    p {
      margin: 30px 0 0 0;
      line-height: 26px;
    }
  }
  @media (min-width: 576px) {
    .topHeader h1 {
      line-height: 50px;
      font-size: 40px;
    }
  }
  @media (min-width: 768px) {
    .topHeader {
      margin-bottom: 180px;
      h1 {
        margin-top: -50px;
      }
    }
  }
  @media (min-width: 992px) {
    .topHeader .container>* {
      max-width: 55%;
      margin-right: auto;
      margin-left: auto;
    }
  }
</style>
<template>
  <header class="topHeader">
    <div class="container">
      <h1>{{title}}</h1>
      <p>{{text}}</p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'FrontendHomeTop',
  computed: {
    title: function () {
      return this.$store.state.loading.txtContent.homeTitle
    },
    text: function () {
      return this.$store.state.loading.txtContent.homeText
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/home/top.vue